import { render, staticRenderFns } from "./IndoorGradeChart.vue?vue&type=template&id=47d638b7&scoped=true"
import script from "./IndoorGradeChart.vue?vue&type=script&lang=js"
export * from "./IndoorGradeChart.vue?vue&type=script&lang=js"
import style0 from "./IndoorGradeChart.vue?vue&type=style&index=0&id=47d638b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d638b7",
  null
  
)

export default component.exports